import React, { Component } from "react";
import Predefine_2_Colar_Goalkeeper from "../components/Predefine_2_Colar_Goalkeeper/Predefine_2_Colar_Goalkeeper";

export class Predefine_2_Colar_GoalkeeperPage extends Component {
  render() {
    return <Predefine_2_Colar_Goalkeeper />;
  }
}

export default Predefine_2_Colar_GoalkeeperPage;
